import styled from "styled-components";

export const CalendarOptionContainer = styled.div`
    flex: grid;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    gap: 20px;
    @media (min-width: 768px) {
        flex-direction: row;
        gap: 30px;
    }
`

export const CalendarPictureAndNameContainer = styled.div`
    display: flex;
    width: 100%;
    gap: 20px;
    align-items: center;
`

export const CalendarIconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    box-shadow: 0 2px 5px 0 rgb(0 0 0/27%);
    width: 50px;
    height: 50px;
    flex-shrink: 0;
`

export const CalendarOptionButton = styled.button`
    font-size: 14px;
    padding: 8px 16px;
    color: #FFF;
    background: #005fe6;
    border-radius: 40px;
    width: 100%;
    @media (min-width: 768px){
        max-width: 180px;
        font-size: 16px;
    }
`